"use strict";
export var GetCapabilitiesStatus = /* @__PURE__ */ ((GetCapabilitiesStatus2) => {
  GetCapabilitiesStatus2["Unknown"] = "Unknown";
  GetCapabilitiesStatus2["Supported"] = "Supported";
  GetCapabilitiesStatus2["Unsupported"] = "Unsupported";
  return GetCapabilitiesStatus2;
})(GetCapabilitiesStatus || {});
